export class AddressValue {
  static WITHOUT_NUMBER = 'S/N';
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/address-value.ts